import React from 'react'

/** Lightweight skeleton for independent card loading states. */
export const OpiCardSkeleton: React.FC<{
  variant?: 'scorecard' | 'table' | 'volume' | 'chart'
}> = ({variant = 'scorecard'}) => {
  if (variant === 'scorecard') {
    return (
      <div className='opi-skeleton opi-skeleton--scorecard' aria-hidden>
        <div className='opi-skeleton__line opi-skeleton__line--sm' />
        <div className='opi-skeleton__line opi-skeleton__line--lg' />
        <div className='opi-skeleton__line' />
        <div className='opi-skeleton__line' />
        <div className='opi-skeleton__line opi-skeleton__line--btn' />
      </div>
    )
  }

  if (variant === 'volume') {
    return (
      <div className='opi-skeleton opi-skeleton--volume' aria-hidden>
        <div className='opi-skeleton__header'>
          <div className='opi-skeleton__line opi-skeleton__line--md' />
          <div className='opi-skeleton__pill' />
        </div>
        <div className='opi-skeleton__line opi-skeleton__line--sm' />
        {[1, 2, 3].map((i) => (
          <div key={i} className='opi-skeleton__volume-item'>
            <div className='opi-skeleton__line opi-skeleton__line--md' />
            <div className='opi-skeleton__row'>
              <div className='opi-skeleton__box' />
              <div className='opi-skeleton__box' />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (variant === 'chart') {
    return (
      <div className='opi-skeleton opi-skeleton--chart' aria-hidden>
        <div className='opi-skeleton__legend'>
          <div className='opi-skeleton__pill' />
          <div className='opi-skeleton__pill' />
        </div>
        <div className='opi-skeleton__bars'>
          {Array.from({length: 8}).map((_, i) => (
            <div
              key={i}
              className='opi-skeleton__bar'
              style={{height: `${40 + ((i * 17) % 50)}%`}}
            />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className='opi-skeleton opi-skeleton--table' aria-hidden>
      <div className='opi-skeleton__line opi-skeleton__line--md' />
      <div className='opi-skeleton__table-rows'>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className='opi-skeleton__line' />
        ))}
      </div>
    </div>
  )
}
